import { render, staticRenderFns } from "./GadgetEditer3.vue?vue&type=template&id=0ed85f83&scoped=true&"
import script from "./GadgetEditer3.vue?vue&type=script&lang=ts&"
export * from "./GadgetEditer3.vue?vue&type=script&lang=ts&"
import style0 from "./GadgetEditer3.vue?vue&type=style&index=0&id=0ed85f83&lang=scss&scoped=true&"
import style1 from "./GadgetEditer3.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed85f83",
  null
  
)

export default component.exports